import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../Services/api-service';
import { ToastrService } from 'ngx-toastr';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-upi-approval',
  templateUrl: './upi-approval.component.html',
  styleUrls: ['./upi-approval.component.css']
})
export class UpiApprovalComponent implements OnInit {
  @ViewChild('dt') dt: Table;

  upiRequests: any[] = [];
  selectedUPIColumns: any[] = [
    //{ field: 'RequestId', header: 'Request ID' },
    { field: 'UserName', header: 'User Name' },
    { field: 'UserMobile', header: 'Mobile' },
    { field: 'CurrentVpaId', header: 'Current UPI' },
    { field: 'RequestedVpaId', header: 'Requested UPI' },
    { field: 'RequestDate', header: 'Request Date' },
    { field: 'Status', header: 'Status' },
    // {
    //   field: 'IsApproved',
    //   header: 'Status',
    //   template: (data) => data.IsApproved ? 'Approved' : 'Pending'
    // },
    { field: 'Remark', header: 'Remarks' },
  ];
  showRemarkDialog: boolean = false;
  remarkForm: FormGroup;
  actionType: string = '';
  selectedRequest: any;
  totalRecords: number = 0;
  loading: boolean = true;
  selectedData: any[] = [];

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private tstr: ToastrService
  ) {
    this.remarkForm = this.fb.group({
      remarks: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.loadUPIRequests();
  }
  loadUPIRequests() {
    this.loading = true;
    const request = {
      Page: 1,
      PageSize: 5,
      SortBy: '',
      SortOrder: 'ASC',
      SearchValue: '',
      IsActive: true
    };

    this.api.PostApi(request, 'HOUser/GetUPIRequests').subscribe(
      (res: any) => {
        this.loading = false;
        if (res.ResponseCode === 200) {
          this.upiRequests = res.ResponseData || [];
          this.totalRecords = this.upiRequests && this.upiRequests.length > 0
            ? this.upiRequests[0].TotalCount
            : 0;
        } else {
          this.tstr.warning(res.ResponseMessage || 'No data found');
          this.upiRequests = [];
          this.totalRecords = 0;
        }
      },
      (error) => {
        this.loading = false;
        this.tstr.error('Error loading UPI requests');
        console.error('API Error:', error);
      }
    );
  }

  lazyLoadUPI(event: any) {
    this.loading = true;
    const request = {
      Page: (event.first / event.rows) + 1,
      PageSize: event.rows,
      SortBy: event.sortField || '',
      SortOrder: event.sortOrder === 1 ? 'ASC' : 'DESC',
      SearchValue: event.globalFilter || '',
      IsActive: true
    };
    console.log('Lazy Load Request:', request);
    this.api.PostApi(request, 'HOUser/GetUPIRequests').subscribe(
      (res: any) => {
        console.log('API Response:', res);
        this.loading = false;
        if (res.ResponseCode === 200) {
          this.upiRequests = res.ResponseData || [];
          this.totalRecords = res.ResponseData && res.ResponseData.length > 0
            ? res.ResponseData[0].TotalCount
            : 0;
        }
      },
      (error) => {
        this.loading = false;
        this.tstr.error('Error loading data');
      }
    );
  }

  openActionDialog(request: any, type: 'approve' | 'reject'): void {
    this.selectedRequest = request;
    this.actionType = type === 'approve' ? 'Approve' : 'Reject';
    this.remarkForm.reset();
    this.showRemarkDialog = true;
  }

  submitAction(): void {
    if (this.remarkForm.invalid) {
      return;
    }

    const actionData = {
      RequestId: this.selectedRequest.RequestId,
      UserID: parseInt(localStorage.getItem("userID")),
      Remarks: this.remarkForm.value.remarks
    };

    if (this.actionType === 'Approve') {
      this.approveUPIRequest(actionData);
    } else {
      this.rejectUPIRequest(actionData);
    }
  }



  approveUPIRequest(request: any) {
    const approvalData = {
      RequestId: request.RequestId,
      UserID: parseInt(localStorage.getItem("userID")),
      ApprovalType: 1,
      Remarks: request.Remarks || "UPI Payment Approved"  // Use existing remarks or default
      //Remarks: "UPI Payment Approved"
    };

    this.api.PostApi(approvalData, 'HOUser/ApproveUPIRequest').subscribe(
      (res: any) => {
        if (res.ResponseCode === 200) {
          this.tstr.success(res.ResponseMessage);
          this.showRemarkDialog = false;
          this.loadUPIRequests();
        } else {
          this.tstr.warning(res.ResponseMessage);
        }
      },
      (error) => {
        this.tstr.error('Error approving request');
      }
    );
  }

  rejectUPIRequest(request: any) {
    const rejectionData = {
      RequestId: request.RequestId,
      UserID: parseInt(localStorage.getItem("userID")),
      ApprovalType: 2,
      Remarks: request.Remarks || "UPI Payment Rejected"  // Use existing remarks or default
      //Remarks: "UPI Payment Rejected"
    };

    this.api.PostApi(rejectionData, 'HOUser/RejectUPIRequest').subscribe(
      (res: any) => {
        if (res.ResponseCode === 200) {
          this.tstr.success(res.ResponseMessage);
          this.showRemarkDialog = false;
          this.loadUPIRequests();
        } else {
          this.tstr.warning(res.ResponseMessage);
        }
      },
      (error) => {
        this.tstr.error('Error rejecting request');
      }
    );
  }
}